export const styles = {
	wrapper: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '24px',
		display: 'flex',
		flexDirection: 'column',
		boxShadow: 'var(--box-shadow--2)',

		'@media (max-width: 1199.98px)': {
			minHeight: 'calc(100vh - 104px)',
			height: '100%',
		},

		'@media (min-width: 1200px)': {
			height: 'calc(100vh - 128px)',
			overflow: 'auto',
		},
	},

	imageWrapper: {
		marginBottom: '24px',

		'& .raffle-banner': {
			width: '100%',
		},
	},

	image: {
		height: '360px',
		width: '100%',
		overflow: 'hidden',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#f5f5f5',

		'@media (max-width: 639.98px)': {
			height: '300px',
			marginBottom: '16px',
		},

		'& img': {
			width: '100%',
			height: '100%',
			display: 'block',
			objectFit: 'cover',
		},
	},
	imageAlt: {
		height: '360px',
		overflow: 'hidden',

		'@media (max-width: 639.98px)': {
			height: '380px',
			marginBottom: '16px',
		},

		'& img': {
			width: '100%',
			height: 'auto',
			maxHeight: '360px',
			objectFit: 'contain',
		},
	},

	dateLabel: {
		fontWeight: '700',
		lineHeight: '1.75',
		marginRight: '24px',
	},

	dateWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'var(--neutral-50)',
		height: '44px',

		'@media (max-width: 767.98px)': {
			height: '48px',
			boxShadow: 'var(--box-shadow--1)',
			borderRadius: '8px',
			border: '1px solid var(--neutral-100)',
		},
	},

	dateItem: {
		display: 'flex',
		marginRight: '16px',

		'&:last-of-type': {
			marginRight: '0',
		},

		'& svg': {
			marginRight: '10px',
		},
	},

	columnWrap: {
		display: 'flex',

		'@media (max-width: 767.98px)': {
			flexDirection: 'column',
			gap: '24px',
		},
	},

	column: {
		width: '50%',

		'@media (max-width: 767.98px)': {
			width: '100%',
		},

		'&:first-of-type': {
			paddingRight: '32px',
			borderRight: '1px solid var(--neutral-100)',

			'@media (max-width: 767.98px)': {
				paddingRight: '0',
				borderRight: 'none',
			},
		},

		'&:last-of-type': {
			paddingLeft: '32px',

			'@media (max-width: 767.98px)': {
				paddingLeft: '0',
			},
		},
	},

	columnCaption: {
		fontWeight: '700',
		lineHeight: '1.75',
		marginBottom: '12px',
	},

	columnText: {
		marginBottom: '16px',
	},

	ticketRow: {
		marginBottom: '12px',
	},

	totalWrap: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	totalText: {
		color: 'var(--primary-700)',
		fontSize: '24px',
		fontWeight: '700',
	},

	iconWrapper: {
		display: 'flex',
		alignItems: 'center',

		svg: {
			path: {
				fill: 'var(--default-white)',
			},
		},
	},

	buttonCreate: {
		fontWeight: 700,
		marginTop: '24px',
	},

	columnLabel: {
		fontSize: '12px',
		color: 'var(--neutral-300)',
	},

	tableHead: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	customeModal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			paddingTop: '48px',
			width: '100%',
		},
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		background: 'var(--default-white)',
		minHeight: 'calc(100vh - 128px)',
		height: '100%',
	},

	contentWrap: {
		width: '100%',
	},

	title: {
		fontWeight: '700',
		fontSize: '20px',
		textAlign: 'center',
		color: 'var(--neutral-900)',
		marginBottom: '40px',
	},

	tiersWrap: {
		width: '100%',
		maxWidth: '495px',
		margin: '0 10px 40px',
		backgroundColor: 'var(--neutral-50)',
		borderRadius: '8px',
		padding: '24px',
	},

	listTitle: {
		fontWeight: '700',
		textAlign: 'center',
		color: 'var(--neutral-900)',
		marginBottom: '24px',
	},

	feeWrap: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: '26px',
	},

	feeLabel: {
		display: 'flex',
		alignItems: 'center',
		gap: '7px',
		'& .checked': {
			path: {
				fill: 'var(--primary-500)',
			},
		},
	},
	paymentWrap: {
		marginBottom: '40px',
		paddingBottom: '60px',

		'@media (max-width: 639.98px)': {
			paddingBottom: '120px',
		},
	},

	popup: {
		display: 'flex',
		gap: '16px',
		padding: '20px',
		height: '100%',

		'@media (max-width: 639.98px)': {
			flexDirection: 'column',
		},
	},

	drawer: {
		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},

	coverFeeTooltip: {
		display: 'flex',

		'& svg': {
			width: '16px',
			height: '16px',
			'& path': {fill: 'var(--neutral-400)'},
		},
	},
};
